import { schema } from 'normalizr';

const getAccountGOSReport = new schema.Entity('accountGOSReport');

export default getAccountGOSReport;
